import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "square", "classes", "children", "className", "CardContentProps"],
  _excluded2 = ["content", "sizeLarge", "fullWidth"];
import { Card, CardContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { clsx } from 'clsx';
import { forwardRef, useState } from 'react';
import { assignRef } from "../utils/mergeRefs.js";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = /*#__PURE__*/makeStyles(theme => ({
  root: {
    '&$fullWidth': {
      borderRadius: 0,
      borderLeftWidth: 0,
      borderRightWidth: 0
    }
  },
  fullWidth: {},
  sizeLarge: {},
  content: {
    padding: theme.spacing(2),
    '$sizeLarge > &': {
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3)
      }
    }
  }
}), {
  name: 'SD-InfoCard'
});
export var InfoCard = /*#__PURE__*/forwardRef((_ref, _ref2) => {
  var {
      size,
      square,
      classes,
      children,
      className,
      CardContentProps: cardContentProps = {}
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles({
      classes
    }),
    {
      content: contentClassName,
      sizeLarge: sizeLargeClassName,
      fullWidth: fullWidthClassName
    } = _useStyles,
    styles = _objectWithoutProperties(_useStyles, _excluded2);
  var [rootNode, setRootNode] = useState(null);
  var clientRect = rootNode === null || rootNode === void 0 ? void 0 : rootNode.getBoundingClientRect();
  var isFullWidth = (clientRect === null || clientRect === void 0 ? void 0 : clientRect.width) === window.innerWidth;
  return /*#__PURE__*/_jsx(Card, _objectSpread(_objectSpread({}, props), {}, {
    ref: node => {
      assignRef(_ref2, node);
      setRootNode(node);
    },
    classes: styles,
    className: clsx(className, {
      [sizeLargeClassName]: size === 'large',
      [fullWidthClassName]: isFullWidth
    }),
    children: /*#__PURE__*/_jsx(CardContent, _objectSpread(_objectSpread({}, cardContentProps), {}, {
      className: clsx(cardContentProps.className, contentClassName),
      children: children
    }))
  }));
});
if (process.env.NODE_ENV !== "production") InfoCard.displayName = "InfoCard";